<template>
	<el-dialog :visible.sync="is_visible" :width="_gHlp.isEmpty(form.redem_date) ? '20%' : (!is_attachment_only ? '80%': '40%')" @close="close">
		<template slot="title">
			<div v-if="!is_attachment_only">
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Redemption' : 'Add Redemption' }}</h3>
			</div>
			<div v-else>
				<h3 class="mb-0 font-weight-500">Attachments</h3>
			</div>
		</template>
		<b-form role="form">
			<b-row>
				<!-- <b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Request Date">
						<el-date-picker v-model="form.request_date" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="Pick a day">
						</el-date-picker>
					</b-form-group>
				</b-col> -->
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Redemption Date">
						<el-date-picker v-model="form.redem_date" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="Pick a day" @change="simulateRedemption">
						</el-date-picker>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Paid Status">
						<el-radio-group size="small" v-model="form.paid_status" fill="#13663E">
							<el-radio-button value="Pending" label="Pending"></el-radio-button>
							<el-radio-button value="Paid" label="Paid"></el-radio-button>
						</el-radio-group>
					</b-form-group>
				</b-col>
				<b-col cols="12" v-if="!is_attachment_only">
					<b-form-group label="Status Redemption">
						<div v-if="!_gHlp.isEmpty(form.apv_id) && !(_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['collection_approval'])))">
							<i>Waiting Approval</i>
						</div>
						<el-select v-model="form.status" placeholder="Select" v-else>
							<el-option :label="'No Selected'" :value="null"></el-option>
							<el-option  v-for="(value,index) in statusList" :key="index" :label="value" :value="value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group :label="!is_attachment_only ? 'Add Attachment (Optional)': null">
						<UploadFiles @addFiles="addFiles" />
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<div class="card-table-simple mb-5" v-loading="is_loading_attachment">
						<b-table-simple responsive class="mb-0">
							<b-thead>
								<b-tr>
									<b-th>Doc Name</b-th>
									<b-th v-if="is_update">Uploaded by</b-th>
									<b-th v-if="is_update">Date</b-th>
									<b-th></b-th>
								</b-tr>
							</b-thead>
							<b-tbody v-if="!_gHlp.isEmpty(currentAttachments) || !_gHlp.isEmpty(newAttachments)">
								<template v-if="is_update">
									<b-tr v-for="(data, index) in currentAttachments" :key="index">
										<b-td @click="$refs.preview_modal.preview(data.url, data.original_filename)"
											class="cursor-pointer text-primary font-weight-500">{{ data.filename }}</b-td>
										<b-td>{{ data.created_by_detail.name }}</b-td>
										<b-td>{{ data.created_at | dateFormatString }}</b-td>
										<b-td>
											<svg @click="deleteFile(data)" xmlns="http://www.w3.org/2000/svg"
												class="text-danger cursor-pointer" width="14" height="18" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
											</svg>
										</b-td>
									</b-tr>
								</template>
								<b-tr v-for="(data, index) in newAttachments" :key="index">
									<b-td class="cursor-pointer text-primary font-weight-500">{{ data.upload.filename }}</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td v-if="is_update">-</b-td>
									<b-td>
										<svg @click="removeFile(data)" xmlns="http://www.w3.org/2000/svg" class="text-danger cursor-pointer"
											width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16m96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16" />
										</svg>
									</b-td>
								</b-tr>
							</b-tbody>
							<b-tbody v-else>
								<b-tr>
									<b-td :colspan="is_update ? 4 : 2">No Attachment</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</div>
				</b-col>
			</b-row>
		</b-form>	
		<div class="table-listings" v-if="!is_attachment_only && !_gHlp.isEmpty(tableData)">
			<h3 class="mb-2 font-weight-500">Simulate Redemption</h3>
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" size="mini">
				<el-table-column label="Options"  min-width="250" label-class-name="py-0">
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.label }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Redemption Date"  min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Redemption Date</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">{{ _gHlp.formatMomentDate(scope.row.due_date,'D MMM, YYYY') }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Last Balance Date"  min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Last Balance Date</span>
					</template>
					<template>
						<p class="top-line">{{ _gHlp.formatMomentDate(form.redem_date,'D MMM, YYYY') }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Last Balance Amount"  min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Last Balance Amount</span>
					</template>
					<template>
						<p class="top-line">{{ form.balance_amt | moneyFormatter }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Formula"  min-width="300" label-class-name="py-0">
					<template slot-scope="scope">
						<div v-if="scope.$index > 0">
							<p class="d-flex  align-items-center justify-content-between">
								<span class="d-block-inline">Previous Balance</span>
								<span class="d-block-inline">{{ _gHlp.getValue(scope.row,'formula.prev_balance',0) | moneyFormatter }}</span>
							</p>
							<p class="d-flex  align-items-center justify-content-between">
								<span class="d-block-inline">Next Month Interest</span>
								<span class="d-block-inline text-success">{{ _gHlp.getValue(scope.row,'formula.interest_amt',0) | moneyFormatter }}</span>
							</p>
							<p class="d-flex  align-items-center justify-content-between">
								<span class="d-block-inline">Advanced Instalment</span>
								<span class="d-block-inline text-danger">{{ _gHlp.getValue(scope.row,'formula.advc_balance',0) | moneyFormatter }}</span>
							</p>
						</div>
						<div v-else>
							last statement balance as of {{ _gHlp.formatMomentDate(scope.row.due_date,'D MMM, YYYY') }}
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Settlement Amount"  min-width="120" label-class-name="py-0">
					<template slot="header">
						<span class="text-break">Balance Amount</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.settlement_amt | moneyFormatter }}</p>
					</template>
				</el-table-column>

				<el-table-column type="expand">
					<template slot-scope="props">
						<div class="p-3">
							<p class="top-line">Detail Repayment Balance</p>
							<ul>
								<li class="text-wrap"  v-for="(item,index) in props.row.breakdown" :key="index">{{ item }}</li>
							</ul>
						</div>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<b-col cols="12" class="text-center mt-4">
			<el-button class="bg-primary text-white w-50" @click.prevent="submit()" :loading="is_loading_btn">{{ is_update ? 'Update' : 'Create'}}</el-button>
		</b-col>
		<PreviewModal ref="preview_modal"></PreviewModal>
	</el-dialog>
</template>
<script>
import { Button, Table, TableColumn, DatePicker, RadioGroup, RadioButton, Dialog, Option, Select } from 'element-ui'
import _ from 'lodash'
import PreviewModal from '@/components/Modal/PreviewModal';
import UploadFiles from '@/views/Widgets/UploadFiles'
import { mapState, mapActions } from 'pinia';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useAttachmentStore } from '@/stores/attachmentStore';
import swal from 'sweetalert2';
import moment from 'moment'

export default {
	components: {
		PreviewModal,
		UploadFiles,
		[Dialog.name]: Dialog,
		[DatePicker.name]: DatePicker,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[RadioGroup.name]: RadioGroup,
		[RadioButton.name]: RadioButton,
		[Option.name]: Option,
		[Select.name]: Select,
	},
	data() {
		return {
			is_visible:false,
			is_update: false,
			is_loading_attachment: false,
			is_loading_btn:false,
			is_attachment_only: false,
			tableData: [],
			statementData: [],
			form: {
				redem_date: null,
				balance_date: null,
				balance_amt: null,
				paid_status: null,
				status: null
			},
			newAttachments: [],
			currentAttachments: [],
			deleteAttachments: []
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase','activeUnpaidRepayments','activeRepayments','activeStatements', 'updateCase']),
		pickerOptions(){
			let min_date = null
			if(!_gHlp.isEmpty(this.activeUnpaidRepayments)){
				const nextRepay = this.activeUnpaidRepayments[0];
				min_date = moment(nextRepay.due_date).subtract(1, 'months').format('YYYY-MM-DD')
			}
			return {
				disabledDate(time) {
					return false; //temporary
					if(_gHlp.isEmpty(min_date)) return false;
					return time.getTime() < new Date(min_date).getTime();
				}
			}
		},
		lastStatement(){
			if(_gHlp.isEmpty(this.activeStatements)) return null;
			return	_.head(_.orderBy(this.activeStatements, ['statement_id'], ['desc']));
		},
		statusList(){
			return (_gHlp.checkAccess(['role_credit_head','role_credit_manager','role_admin','role_super_admin']) || (!_gHlp.checkAccess(['collection_approval']))) ? ['Pending', 'Submitted','Approved','Rejected', 'Expired', 'Payment Received'] : ['Pending', 'Submitted', 'Expired', 'Payment Received'];
		}
	},
	methods: {
		...mapActions(useLoanCaseStore, ['createRedem','updateRedem','getStatementList']),
		...mapActions(useCustomerStore, ['getDocTypes', 'getCustDocs', 'downloadCustDoc', 'removeCustDoc']),
		...mapActions(useAttachmentStore, ['getAttachmentList', 'detailAttachment', 'uploadAttachment', 'deleteAttachment']),
		async show(editData=null, attachment_only=false){
			if (!_gHlp.isEmpty(editData)) {
				this.setForm(editData);
				this.tableData = _.cloneDeep(editData.simulate_detail);
			}
			this.is_visible = true
			this.is_attachment_only = attachment_only;
			this.statementData = _gHlp.getValue(await this.getStatementList({paginate: 'no_paginate'}),'data',[]);
			this.is_loading_btn = false
		},
		close() {
			this.clean();
			this.is_loading_btn = false
			this.is_visible = false
		},
		clean() {
			this.form = {
				redem_date: null,
				balance_date: null,
				balance_amt: null,
				paid_status: null,
				status: null
			}
			this.min_date = null;
			this.newAttachments = [];
			this.currentAttachments = [];
			this.deleteAttachments = [];
			this.is_update = false
		},
		// disabledDate(time) {
		// 	if(_gHlp.isEmpty(this.min_date)) return false;
    //   // Disable dates before January 1st, 2024
    //   return time.getTime() < new Date(this.min_date).getTime();
    // },
		setForm(editData) {
			// this.clean();
			this.is_update = true;
			this.form = editData;
			// this.form.amount = this.form.transaction == 'Debit' ?  editData.debit :  editData.credit;
			this.getAttachments();
		},
    generateSimulateBreakdown(repayment, tmp_next_balance, tmp_advc_balance, tmp_interest_amt = 0, tmp_due_date = '') {
				// console.log({repayment, tmp_next_balance, tmp_advc_balance, tmp_interest_amt, tmp_due_date});
				let txt = '';
				let txtArr = [];
				let txtMin = [];
				let tmp_repay_amt = 0;
				let tmp_charge_amt = 0;

				if(tmp_next_balance > 0){
					txtArr.push('Prev Ballance (RM '+ _gHlp.formatToMoney(tmp_next_balance) + ')');
				}

				if(tmp_interest_amt > 0){
					txtArr.push('Month Interest (RM '+ _gHlp.formatToMoney(tmp_interest_amt) + ')');
				}

				if(!_gHlp.isEmpty(repayment)){
					tmp_due_date =  _gHlp.formatDate(repayment.due_date,'Y-m-d')

					tmp_repay_amt = parseFloat(_gHlp.getValue(repayment,'repayment_amt',0))
					txtMin.push('Month Repay (RM '+ _gHlp.formatToMoney(tmp_repay_amt) + ')');
					
					tmp_charge_amt = parseFloat(_gHlp.getValue(repayment,'late_charge_amt',0))
					let tmp_late_days = parseInt(_gHlp.getValue(repayment,'late_days',0))
					if(tmp_charge_amt > 0){
						txtArr.push('Late Charge ('+ tmp_late_days +' Days : RM ' +_gHlp.formatToMoney(tmp_charge_amt)+')');
					}
				}

				txt = txtArr.join(' + ');
				if(tmp_advc_balance > 0 && (tmp_repay_amt > 0)){
					if(parseFloat(tmp_repay_amt) <=  parseFloat(tmp_advc_balance)){
						txtMin.push('Advance Balance (RM '+ _gHlp.formatToMoney(tmp_repay_amt) + ')');
						
						tmp_repay_amt = 0;
						tmp_advc_balance = parseFloat(tmp_advc_balance) - parseFloat(tmp_repay_amt);
						
					}else{
						txtMin.push('Advance Balance (RM '+ _gHlp.formatToMoney(tmp_advc_balance) + ')');
						tmp_repay_amt = parseFloat(tmp_repay_amt) - parseFloat(tmp_advc_balance);
						tmp_advc_balance = 0;
					}
				}

				if(!_gHlp.isEmpty(txtMin)){
					if(txtMin.length > 1){
						txt = '( '+txt+' ) - ('+ txtMin.join(' - ') + ') ';
					}else{
						txt = '( '+txt+' ) - '+ txtMin.join(' - ') + ' ';
					}
				}

				let tmp_prev_balance =  parseFloat(tmp_next_balance) + parseFloat(tmp_charge_amt) - parseFloat(tmp_repay_amt);
				let tmp_curr_balance =  parseFloat(tmp_prev_balance) + parseFloat(tmp_interest_amt);
				let new_next_balance =  parseFloat(tmp_curr_balance);
				txt += '= Balance (RM '+ _gHlp.formatToMoney(new_next_balance) + ') ';

        return [
						tmp_interest_amt,
            tmp_advc_balance,
            tmp_prev_balance,
            tmp_curr_balance,
            new_next_balance,
            tmp_due_date,
            txt
				];
    },

		simulateRedemption(selected_date){
			const listRepaymments = _.cloneDeep(this.activeRepayments);
			const listStatements = _.cloneDeep(this.statementData);
			this.tableData = [];
			let lastStatement = null;
			if(!_gHlp.isEmpty(listStatements)){
				for (let i = 0; i < listStatements.length; i++) {
					const el = listStatements[i]
					if(moment(el.statement_date).format('YYYY-MM-DD') >= moment(selected_date).format('YYYY-MM-DD')){
						if(moment(el.statement_date).format('YYYY-MM-DD') == moment(selected_date).format('YYYY-MM-DD')){
							lastStatement = listStatements[i];
						}
						break;
					}
					lastStatement = listStatements[i];
				}
			};

			const last_due_date = _gHlp.getValue(lastStatement,'due_date',_gHlp.getValue(lastStatement,'statement_date',_gHlp.getCurrentDateTime(false)));
			const last_is_interest = _gHlp.getValue(lastStatement,'category',null) == "Interest";

			let reedm_repaymet = [];
			if(!_gHlp.isEmpty(listRepaymments)){
				for (let i = 0; i < listRepaymments.length; i++) {
					const el = listRepaymments[i]
					if(new Date(el.due_date).getTime() >= new Date(last_due_date).getTime()){
						reedm_repaymet.push(el);
						if(new Date(el.due_date).getTime() > new Date(selected_date).getTime()){
							reedm_repaymet.push(listRepaymments[i+1]);
							break;
						}
					}
				}
			};

			
			const redem_2nd = ((reedm_repaymet.length > 1) && !_gHlp.isEmpty(reedm_repaymet[reedm_repaymet.length - 1])) ? reedm_repaymet.pop() : null;
			const redem_1st = ((reedm_repaymet.length > 0) && !_gHlp.isEmpty(reedm_repaymet[reedm_repaymet.length - 1])) ? reedm_repaymet.pop() : null;
			const redem_remain = reedm_repaymet;

			let tmp_due_date =  null
			let tmp_prev_balance = 0;
			let tmp_curr_balance = 0;
			let tmp_interest_amt = last_is_interest ? _gHlp.getValue(lastStatement,'credit',0) : 0;
			let tmp_next_balance = parseFloat(_gHlp.getValue(lastStatement,'balance',0)) - parseFloat(tmp_interest_amt);
			let tmp_advc_balance = _gHlp.getValue(lastStatement,'advance_balance',0);
			let tmp_formula= null;
			let repayment = null;
			let breakdown = [];
			let txt = '';
			console.log(lastStatement);
			//REQUEST REDEMPTION
			[tmp_interest_amt, tmp_advc_balance, tmp_prev_balance, tmp_curr_balance, tmp_next_balance, tmp_due_date, txt] = this.generateSimulateBreakdown(null, tmp_next_balance, tmp_advc_balance, tmp_interest_amt,last_due_date);
			breakdown.push('Period '+ tmp_due_date + ': ' + txt);
			if(tmp_prev_balance > 0){
				breakdown.push('Adv. Balance (RM '+ _gHlp.formatToMoney(tmp_advc_balance) + ')');
			}

			for (let i = 0; i < redem_remain.length; i++) {
				repayment = redem_remain[i];	
				[tmp_interest_amt, tmp_advc_balance, tmp_prev_balance, tmp_curr_balance, tmp_next_balance, tmp_due_date, txt] = this.generateSimulateBreakdown(repayment, tmp_next_balance, tmp_advc_balance, _gHlp.getValue(repayment,'interest_amt',0));
				breakdown.push('Period '+ tmp_due_date + ': ' + txt);
				if(tmp_prev_balance > 0){
					breakdown.push('Adv. Balance (RM '+ _gHlp.formatToMoney(tmp_advc_balance) + ')');
				}
			}

			tmp_formula = {
				prev_balance: tmp_prev_balance,
				interest_amt: tmp_interest_amt,
				advc_balance: tmp_advc_balance,
			}

			this.form.balance_date = tmp_due_date
			this.form.balance_amt = tmp_prev_balance
			this.tableData.push({
				label: 'Redemption Request Date',
				due_date: tmp_due_date,
				formula: tmp_formula,
				settlement_amt: tmp_next_balance,
				rpay_id: _gHlp.getValue(repayment,'rpay_id'),
				breakdown: breakdown
			})

			// 1ST REDEMPTION
			if(!_gHlp.isEmpty(redem_1st)){
					breakdown = [];
					[tmp_interest_amt, tmp_advc_balance, tmp_prev_balance, tmp_curr_balance, tmp_next_balance, tmp_due_date, txt] = this.generateSimulateBreakdown(redem_1st, tmp_next_balance, tmp_advc_balance, _gHlp.getValue(redem_1st,'interest_amt',0));
					breakdown.push('Period '+ tmp_due_date + ': ' + txt);

					if(tmp_prev_balance > 0){
						breakdown.push('Adv. Balance (RM '+ _gHlp.formatToMoney(tmp_advc_balance) + ')');
					}

					tmp_formula = {
						prev_balance: tmp_prev_balance,
						interest_amt: tmp_interest_amt,
						advc_balance: tmp_advc_balance,
					}

					this.tableData.push({
						label: '1st Redemption Expired Date',
						due_date: _gHlp.formatDate(redem_1st.due_date,'Y-m-d'),
						formula: tmp_formula,
						settlement_amt: tmp_next_balance,
						rpay_id: redem_1st.rpay_id,
						breakdown: breakdown
					})
			}

			// 2ND REDEMPTION
			if(!_gHlp.isEmpty(redem_2nd)){
					breakdown = [];
					[tmp_interest_amt, tmp_advc_balance, tmp_prev_balance, tmp_curr_balance, tmp_next_balance, tmp_due_date, txt] = this.generateSimulateBreakdown(redem_2nd, tmp_next_balance, tmp_advc_balance, _gHlp.getValue(redem_2nd,'interest_amt',0));
					breakdown.push('Period '+ tmp_due_date + ': ' + txt);
				
					if(tmp_prev_balance > 0){
						breakdown.push('Adv. Balance (RM '+ _gHlp.formatToMoney(tmp_advc_balance) + ')');
					}

					tmp_formula = {
						prev_balance: tmp_prev_balance,
						interest_amt: tmp_interest_amt,
						advc_balance: tmp_advc_balance,
					}

					this.tableData.push({
						label: '2nd Redemption Expired Date',
						due_date: _gHlp.formatDate(redem_2nd.due_date,'Y-m-d'),
						formula: tmp_formula,
						settlement_amt: tmp_next_balance,
						rpay_id: redem_2nd.rpay_id,
						breakdown: breakdown
					})
			}
			// console.log(this.tableData);
		},
		addFiles(items) {
			for (let i = 0; i < items.length; i++) {
				this.newAttachments.push(items[i]);
			}
		},
		removeFile(file) {
			this.newAttachments = this.newAttachments.filter(item => {
				return item.upload.uuid != file.upload.uuid;
			});
		},
		submit() {
			let params = {}
			if(this.is_attachment_only){
				params = {
					...this.form,
					total_attachment: this.currentAttachments.length + this.newAttachments.length
				}
			}else{
				params = {
					...this.form,
					total_attachment: this.currentAttachments.length + this.newAttachments.length,
					status: (this.is_attachment_only || ['Expired','Payment Received','Approved','Rejected'].includes(this.form.status) ) ? this.form.status : 'Pending'
				}
			}
			if (this.form.redem_id) {
				this.is_loading_btn = true;
				this.updateRedem(this.form.redem_id, params).then((resp) => {
					this.submitUploadAttachments();
					this.submitRemoveAttachments();

					if(this.form.status == 'Approved'){
						this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
							gEventBus.$emit('refresh-cases');
							this.$emit('closeModal',true);
							_gNotif.notifySuccess('<b>Redemption</b> - Successfully Updated.')
							this.is_loading_btn = false;
							this.is_visible = false
						}).catch((e) => {
							_gNotif.notifyError('Failed regenerate sattement');
							this.is_loading_btn = false;
							this.is_visible = false
						})
					}else{
						gEventBus.$emit('refresh-cases');
						this.$emit('closeModal',true);
						_gNotif.notifySuccess('<b>Redemption</b> - Successfully Updated.')
						this.is_loading_btn = false;
						this.is_visible = false
					}
				});
			} else {
				this.is_loading_btn = true;
				this.createRedem(params).then((resp) => {
					this.form.redem_id = resp.redem_id;
					this.form.case_id = resp.case_id;
					this.submitUploadAttachments();
					
					if(this.form.status == 'Approved'){
						this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
							gEventBus.$emit('refresh-cases');
							this.$emit('closeModal',true);
							_gNotif.notifySuccess('<b>Redemption</b> - Successfully Created.')
							this.is_loading_btn = false;
							this.is_visible = false
						}).catch((e) => {
							_gNotif.notifyError('Failed regenerate sattement');
							this.is_loading_btn = false;
							this.is_visible = false
						})
					}else{
						gEventBus.$emit('refresh-cases');
						this.$emit('closeModal',true);
						_gNotif.notifySuccess('<b>Redemption</b> - Successfully Created.')
						this.is_loading_btn = false;
						this.is_visible = false
					}
				});
			}
		},

		submitRemoveAttachments() {
			if (_gHlp.isEmpty(this.deleteAttachments)) return false
			for (let i = 0; i < this.deleteAttachments.length; i++) {
				const itm = this.deleteAttachments[i];
				this.deleteAttachment(itm)
			}
		},
		submitUploadAttachments() {
			if (_gHlp.isEmpty(this.newAttachments)) return false
			let attachments = this.newAttachments;
			let owner_type = 'loan_redemption';
			let owner_id = this.form.redem_id;
			let tags = 'lms_' + this.form.case_id + '_case';

			for (let i = 0; i < this.newAttachments.length; i++) {
				const itm = this.newAttachments[i];
				let params = {
					folder: 'lms/' + owner_type + '/' + owner_id,
					owner_type: owner_type,
					owner_id: owner_id,
					// attachment_category_id: null,
					attachment_tags: tags,
					file: itm
				}
				this.uploadAttachment(params)
			}
		},
		getAttachments() {
			this.is_loading_attachment = true;
			this.getAttachmentList({ owner_id: this.form.redem_id, owner_type: 'loan_redemption' }).then(resp => {
				this.currentAttachments = resp.data;
				this.is_loading_attachment = false;
			}).catch(e => {
				_gNotif.errorFunction(e);
				this.is_loading_attachment = false;
			});
		},
		deleteFile(attachment) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					if (_gHlp.isEmpty(this.currentAttachments)) return false
					this.currentAttachments = this.currentAttachments.filter(item => {
						return item.attachment_id != attachment.attachment_id;
					});
					this.deleteAttachments.push(attachment.attachment_id)
				}
			});
		}
	}
}
</script>